<template>
  <div class="dialogWrap">
    <!-- 清除实名成功提示 -->
    <el-dialog
        title="清除成功"
        :visible.sync="clearSuccess"
        width="380px"
        top="27vh"
        class="myDialog"
        center
        :before-close="close"
        :close-on-click-modal="false"
    >
      <div class="dialog-content-center">您的实名认证信息已清除成功。</div>
      <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="close">好的</el-button>
            </span>
    </el-dialog>

    <!-- 未绑定手机号 -->
    <el-dialog
        title="提示"
        :visible.sync="noBindPhone"
        width="380px"
        top="27vh"
        class="myDialog"
        center
        :before-close="close"
        :close-on-click-modal="false"
    >
      <div class="dialog-content-center">您需要先绑定手机号。</div>
      <span slot="footer" class="dialog-footer">
                <el-button round class="next" @click="close">取消</el-button>
                <el-button round type="primary" @click="$router.push('/userCenter/association')">去绑定</el-button>
            </span>
    </el-dialog>
    <!-- 风险提示 -->
    <el-dialog
        title="确认清除实名认证信息？"
        :visible.sync="riskAlert"
        width="610px"
        top="27vh"
        class="myDialog clearNameDia"
        center
        :before-close="close"
        :close-on-click-modal="false"
    >
      <el-row :gutter="24" type="flex" class="row-bg" justify="center">
        <el-col :span="24">
          <p>
            清除实名认证信息后，<b>您的账号仍可登录，但基于当前实名信息开通的服务及未完结事项将被终止或关闭</b>。请您充分知悉并评估可能产生的影响，包括但不限于：
          </p>
          <p>
            1.无法继续使用需实名认证的部分功能或服务；所有分享的证据将无法查看;
          </p>
          <p>
            2.与实名信息关联的部分数据、记录或服务进度可能永久丢失或无法恢复；
          </p>
          <p>
            3.如遇纠纷或需司法举证，您需自行向相关机构证明账号归属，平台可能无法仅凭账号信息直接证明您的身份，且过程可能复杂耗时；
          </p>
          <p>
            4.清除实名信息后您可重新认证，但仅限认证为清除之前的同一实质性主体(证件号相同)。
          </p>
        </el-col>
      </el-row>
      <p class="agreement" style="padding-top:20px">
        <el-checkbox v-model="checked">我已了解上述风险，并接受因此带来的全部后果和责任。仍要求立即清除本账号的实名认证信息。</el-checkbox>
      </p>
      <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="close">取消</el-button>
                <el-button round class="next" @click="goOn">继续</el-button>
            </span>
    </el-dialog>
    <!-- 验证手机号 -->
    <el-dialog
        title="身份验证"
        :visible.sync="authenticate"
        width="480px"
        top="27vh"
        class="myDialog"
        center
        :before-close="close"
        :close-on-click-modal="false"
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <p class="tips">为验证您的身份，需要使用您的手机<b>{{ userInfo.phone }}</b>收取短信验证码。</p>
          <el-form
              :model="verifyPhoneForm"
              status-icon
              :rules="rulesPhone"
              ref="verifyPhoneForm"
              label-width="0px"
              class="demo-ruleForm"
          >
            <el-input
                type="hidden"
                v-model="verifyPhoneForm.phone"
                autocomplete="off"
                clearable
                placeholder="请输入要绑定的手机号"
            ></el-input>
            <el-form-item prop="code">
              <el-input
                  type="text"
                  v-model="verifyPhoneForm.code"
                  autocomplete="off"
                  clearable
                  placeholder="请输入验证码"
                  class="codeIpt"
              >
                                <span class="yzm" slot="append" :disabled="disabled" @click="getVerificationCode">
                                    {{ yzmtext }}
                                </span>
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button round class="next" @click="close">取消</el-button>
                <el-button round type="primary" @click="handlSub('verifyPhoneForm')">提交</el-button>
            </span>
    </el-dialog>
    <div id="captcha-element"></div>
  </div>
</template>

<script>
import {sendMsg, clearRealName} from '@http/user_center/realName'
import NoTrace from '@/utils/noTrace';
import { watch } from 'less';
let interval = null;
let time = 61;
export default {
  name: 'ClearRealName',
  data() {
    var vCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      }
      if (value.trim().length == 0) {
        callback(new Error("验证码不能为空"));
      }
      callback();
    };
    return {
      clearSuccess: false,
      noBindPhone: false,
      riskAlert: false,
      authenticate: false,
      yzmtext: "获取验证码",
      disabled: false,
      currentTime: 61,
      userInfo: {},
      checked: false,//是否阅读协议
      verifyPhoneForm: {
        phone: '',
        code: '',
      },
      rulesPhone: {
        code: [{validator: vCode}],
      },
    }
  },
  components: {},
  computed: {
    channelCodeValue() {
      return this.$store.state.config.channelCodeValue;
    },
  },
  watch:{
    checked(val){
      if(val){
        this.$TsaWebTrace.post({
            data: {
                "eventId": 557378,
            },
        });
      }else{
        this.$TsaWebTrace.post({
            data: {
                "eventId": 557379,
            },
        });
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
      NoTrace.init('captcha-element', 'captcha-button')
  },
  beforeDestroy() {
      NoTrace.reset()
  },
  methods: {
    init() {
      this.userInfo = this.$store.state.userInfo.userinfo;
      this.verifyPhoneForm.phone = this.$store.state.userInfo.userinfo.phone;
      if (!this.userInfo.phone) {
        this.noBindPhone = true;
      } else {
        this.riskAlert = true;
      }
    },
    close() {
      this.clearSuccess = false;
      this.noBindPhone = false;
      this.riskAlert = false;
      this.authenticate = false;
      this.$store.dispatch('userInfo/setLawyerInfo', {})
      this.$emit('closeProcess')
    },
    resetYzm(btnStatus = 1) {
      this.disabled = false;
      interval && clearInterval(interval);
      this.yzmtext = btnStatus == 0 ? "获取验证码" : '重新获取';
      this.currentTime = time;
    },
    getVerificationCode() {
      let that = this;
      this.getCode();
      this.disabled = true;

      // 开始获取无痕验证码
      NoTrace.start((nvc) => {
          this.nvc = nvc
      }, this.executeFun, {
          phone: that.userInfo.phone,
          nvc: '',
          afsVersion: 2
      })
    },
    executeFun (params) {
        let that=this;
        return new Promise(async (resolve, reject) => {
            try {
                let res = await sendMsg(params);
                resolve(res)
                this.$msg("验证码已发送，请注意接收", "success");
            }catch (err) {
                reject(err)
                that.$msg(err.message);
                that.resetYzm();
            }
        })
    },
    getCode() {
      var that = this;
      var currentTime = that.currentTime;
      interval = setInterval(function () {
        currentTime--;
        that.yzmtext = "(" + currentTime + "s)重新获取";
        if (currentTime <= 0) {
          that.resetYzm();
        }
      }, 1000);
    },
    goOn() {
      if (this.checked) {
        this.riskAlert = false;
        this.authenticate = true;
      } else {
        this.$msg("请先阅读风险提示并勾选");
      }
    },
    handlSub(verifyForm) {
      zhuge.track('用户中心_清除实名提交', {'渠道': this.channelCodeValue})
      let that = this;
      this.$refs[verifyForm].validate((valid) => {
        if (valid) {
          clearRealName(this.verifyPhoneForm).then((res) => {
            that.authenticate = false;
            this.$emit('reload')
            that.clearSuccess = true;
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 557380,
                },
            });
            that.$store.dispatch('userInfo/setLawyerInfo', true)
          }).catch((err) => {
            console.log(err)
            //that.$msg(err.message)
          });
        }
      })
    }
  },
}

</script>
<style src="@/assets/css/dialog.less" scoped lang='less'></style>
<style scoped lang='less'>
.clearNameDia{
  p{
    line-height: 1.5;
    b{
      font-weight: bold;
      text-decoration: underline;
    }
  }
  .agreement{
    /deep/.el-checkbox{
      white-space: wrap;
      display: flex;
      text-align: left;
      .el-checkbox__input{
        .el-checkbox__inner{
          margin-top: 2px;
        }
      }
      
      .el-checkbox__label{
        white-space: wrap;
      }
    }
  }
}
</style>